const extendedProjectsCopy = {
  "extended project new construction": "Complete construction",
  "extended project remodel": "Complete remodel",
  "extended project re-roof": "Complete re-roof",
  "extended project resume project": "Resume project",
  "extended project operations assistance": "Complete operations assistance"
};

export default extendedProjectsCopy;
